module.exports = __webpack_public_path__ + "img/fruitsSmall.837a9288.jpg";